import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FieldType } from '@ngx-formly/core';
import { ContextService } from '../../context.service';
import { HttpClient } from '@angular/common/http';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';

@Component({
    selector: 'mutara-send-message-dialog',
    templateUrl: './send-message-dialog.component.html',
    standalone: false
})

export class SendMessageDialogComponent extends FieldType implements OnInit {
    messageForm: FormGroup;
    delegateName: string = 'Applicant';
    showSentMessage: boolean = false;
    showRequiredMessage: boolean = false;

    /**
     * Class implementation
     * @param contextSettings 
     * @param dialogRef 
     */
    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private contextSettings: ContextService,
        private dialogRef: MatDialogRef<SendMessageDialogComponent>,
        private http: HttpClient,
        private fb: UntypedFormBuilder
    ) {
        super();
        this.messageForm = this.fb.group({
            messageSubject: [null, [Validators.required]],
            messageText: [null, [Validators.required]],
        });
    }

    ngOnInit() {
        this.delegateName = this.dialogRef.componentInstance.data.delegateName || 'Applicant';
    }

    /**
     * Send the message (text or email) to the delegate user
     * @param messageType 
     * @returns 
     */
    sendMessage(messageType: string = "email") {

        this.showRequiredMessage = this.showSentMessage = false;

        if (!this.messageForm.value.messageSubject || !this.messageForm.value.messageText) {
            this.showRequiredMessage = true;
            return;
        }

        let personId = this.dialogRef.componentInstance.data.personId;

        this.http.post('$service/send-message', {
            personId: personId,
            message: 'custom-message',
            customMessageSubject: this.messageForm.value.messageSubject.trim(),
            customMessageText: this.messageForm.value.messageText.trim(),
            messageType: messageType
        }).subscribe({
            next: () => {
                this.contextSettings.changeMessage('Message sent');
                this.showSentMessage = true;
                this.messageForm.reset();
            }
        });
    }
}